import React from 'react';
import { Link } from 'react-router-dom';
import { formatDate } from 'client/helpers';
import { JPEG_QUALITY } from 'client/constants';
import noImage from 'client/img/news-no-image.png?url';
import { Picture } from 'components';

export default ({ article }) => {
	if (!article)
		return (
			<div className='big-article'>
				<div className='content' />
			</div>
		);
	const stringWithoutTags = article.text?.replace(/(<([^>]+)>)/gi, '');
	return (
		<Link to={`/news/${article.id}`} className='big-article' alt={article.title}>
			<div className='content'>
				<div className='image'>
					{article.image ? (
						<Picture src={article.downloadFile('image') + `?image=[{"resize":{"width":590}}${JPEG_QUALITY}]`} alt={article.title} />
					) : (
						<Picture src={noImage} alt={article.title} className='no-image' />
					)}
				</div>
				<div className='title h6'>{article.title}</div>
				<div className='text p2' dangerouslySetInnerHTML={{ __html: stringWithoutTags }} />
				<div className='info'>
					<div className='date p3'>{article.topics?.name}</div>
					<div className='date p3'>{formatDate(article.publishAt)}</div>
				</div>
			</div>
		</Link>
	);
};
